import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Header from "../components/Header";
import Footer from "../components/Footer";

const RequireAuth = ({ children, isHeaderRequired, isFoterRequired }) => {
  const location = useLocation();

  const userDetail = useSelector((state) => state.basicInfo?.userDetails);
  const userType = useSelector(e => e?.basicInfo?.userDetails?.user_type)

  let hasAuthToken = false;
  let authTk = JSON.parse(localStorage.getItem("auth_token"))?.access;
  if (!["", null, undefined].includes(authTk)) {
    hasAuthToken = true;
  }

  if (!hasAuthToken) {
    return <Navigate to="/auth/sign-in" state={{ path: location.pathname }} />;
  }

  return (
    <div className="clint-body">
      <div>
        <div className="welcome-message dashboard-welcome-message">
          <p>
            Welcome 
            {' '}
            {userDetail?.user_type === 'shipper' && 'Shipper'}
            {userDetail?.user_type === 'carrier' && 'Carrier'} 
            {' : '}
            {userDetail?.full_name}
          </p>
          <p className="col-lg-8 m-auto" style={{fontStyle: 'italic'}}>
            To fully benefit from the Poncore Dispatch platform, 
            {
              userType === "shipper" &&
              <span> shipper</span>
            }

            {
              userType === "carrier" &&
              <span> carrier</span>
            } should ensure their accounts are accurately and completely set up. 
            Incomplete or inaccurate account details may delay approval, void transactions, and 
            potentially result in account deactivation.
          </p>
        </div>
        {isHeaderRequired !== false && <Header />}
        {children}
      </div>
      {isFoterRequired !== false && <Footer />}
    </div>
  );
};

export default RequireAuth;
